import PageShell from './PageShell'
import { LoadingOverlay } from '@mantine/core'

export function RouteLoading({ title, fullWidth = false }: { title: string; fullWidth?: boolean }) {
  return (
    <PageShell title={title} fullWidth={fullWidth}>
      <LoadingOverlay visible={true} />
    </PageShell>
  )
}
